<template>
    <div>
        <div class="share-link-container rounded-sm mb-1">
            <div class="d-flex align-items-center">
                <input
                    class="flex-grow-1 mr-3 form-control form-control-sm share-link text-primary"
                    readonly
                    type="text"
                    v-model="copyLink"
                />
                <div class="flex-grow-0 flex-shrink-0">
                    <button class="btn btn-gray btn-sm" @click="copyShareLink()">
                        <!-- <span class="icon icon-glyphicons-basic-squares mr-1"></span> -->
                        <span>{{ copyBtnLabel }}</span>
                    </button>
                </div>
            </div>
        </div>
        <div class="small text-secondary mr-3" v-show="copyLinkSuccessful">
            <span class="icon icon-glyphicons-basic-circle-check text-success"></span>
            {{ successMessage }}
        </div>
    </div>
</template>

<script>
export default {
    name: "CopyLinkInput",
    props: {
        value: {
            type: String,
            required: false,
        },
        copyBtnLabel: {
            type: String,
            default: "Copy Link",
            required: false,
        },
        successMessage: {
            type: String,
            default: "Link copied to clipboard",
            required: false,
        },
    },
    data() {
        return {
            copyLink: this.value,
            copyLinkSuccessful: false,
        }
    },
    watch: {
        value: function(newValue) {
            this.copyLink = newValue
        },
    },
    methods: {
        copyShareLink() {
            let vm = this
            navigator.clipboard.writeText(this.copyLink).then(function () {
                vm.copyLinkSuccessful = true
            })
        },
        reset() {
            this.copyLinkSuccessful = false
        },
    },
}
</script>

<style lang="scss" scoped>
@import "@/assets/styles/variables.scss";

.share-link-container {
    padding-top: 8px;
    padding-bottom: 8px;
    padding-left: 10px;
    padding-right: 10px;
    background-color: $gray-100;
}

.share-link {
    font-size: 14px;
    background-color: transparent;
    &:not(:focus) {
        border-color: transparent;
    }
}
</style>